import { useDraggable } from "@dnd-kit/core";
import { nanoid } from "nanoid";
import { useRef } from "react";

import { fields } from "./Elements";

interface Field {
  type: string;
  title: string;
  icon?: string | null;
  size: number
  category: string
}

interface SidebarFieldProps {
  field: Field;
  overlay?: boolean;
}

export function SidebarField({ field, overlay}: SidebarFieldProps) {
  const { title } = field;

  let className = "sidebar-field";
  
  if (overlay) {
    className += " overlay";
  }

  return <div className={className}>{title}</div>;
}

interface DraggableSidebarFieldProps {
  field: Field;
  onlyOneThird?: boolean;
  disabled?: boolean;
}

function DraggableSidebarField({ field, onlyOneThird = false, disabled = false }: DraggableSidebarFieldProps) {
  const id = useRef(nanoid());

  const { attributes, listeners, setNodeRef } = useDraggable({
    id: id.current,
    data: {
      field,
      fromSidebar: true,
    },
  });

  return (
    <div ref={setNodeRef} className={`sidebar-field ${disabled ? 'disabled' : ''}`} {...attributes}>
      {disabled ? (
        <div className="sidebar-field-drag-handle"><i className={field.icon ?? ''}></i></div>
      ) : (
        <div className="sidebar-field-drag-handle" {...listeners}><i className={field.icon ?? ''}></i></div>
      )}
      <SidebarField field={field} />
      {!onlyOneThird && (
        <i className={field.size === 3 ? "fas fa-window-maximize" : "fas fa-stop"}></i>
      )}
    </div>
  );
}

interface SidebarProps {
  fieldsRegKey?: string;
  appType?: string;
  onlyOneThird?: boolean;
  disabled?: boolean;
}

export default function Sidebar({ fieldsRegKey, appType, onlyOneThird = false, disabled = false }: SidebarProps) {
  return (
    <div key={fieldsRegKey} className="sidebar">
      {fields
        .filter(f => {
          // Se onlyOneThird for true, remove os fields com size === 3
          if (onlyOneThird && f.size === 3) return false;
          
          // Mantém a condição original para church
          return (f.category !== 'church' || 
                 ['web-church', 'web-church-tv', 'web-church-radio', 'web-church-tv-radio']
                 .includes(appType ?? 'general'));
        })
        .map((f) => (
          <DraggableSidebarField 
            key={f.type} 
            field={f} 
            onlyOneThird={onlyOneThird}
            disabled={disabled}
          />
        ))}
    </div>
  );
}
